import './Order.css';

export default function Order() {
    return <div id='order'>

    </div>;
}
